module.exports = __webpack_public_path__ + "media/images/emblems/Meinisberg-coat_of_arms-e70dee37b3b0ce3020b6b2aa02279676.svg";